import { render, staticRenderFns } from "./DonutChart86.vue?vue&type=template&id=75bb10b4&scoped=true&"
import script from "./DonutChart86.vue?vue&type=script&lang=js&"
export * from "./DonutChart86.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb10b4",
  null
  
)

export default component.exports